import { SvgIcon } from '@mui/material';

import { ReactComponent as LogoRoot } from '../media/cyh-logo.svg';

const Logo = (props) => (
  <SvgIcon
    viewBox="0 0 74 23"
    sx={{
      width: 'auto',
      height: 'auto',
      ...props.sx
    }}
    {...props}
  >
    <title>Choose Your Horizon</title>
    <LogoRoot />
  </SvgIcon>
);

export default Logo;
